import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveDirective as _resolveDirective, withDirectives as _withDirectives, withModifiers as _withModifiers } from "vue"
import _imports_0 from '@assets/support.png'
import _imports_1 from '@assets/logo2.svg'


const _hoisted_1 = { class: "status-extended d-flex align-content-center flex-row justify-content-center" }
const _hoisted_2 = { class: "mt-10" }
const _hoisted_3 = { class: "row justify-content-between align-items-center" }
const _hoisted_4 = { class: "text-center status-page-nav-bar" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("i", { class: "mdp-ChevronLeft mr-1" }, null, -1)
const _hoisted_6 = { class: "row system-status mt-10" }
const _hoisted_7 = { class: "col-lg-12" }
const _hoisted_8 = { class: "card-body" }
const _hoisted_9 = { class: "status-title" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("i", { class: "mdp-Refresh" }, null, -1)
const _hoisted_11 = [
  _hoisted_10
]
const _hoisted_12 = { class: "d-flex status-node-container" }
const _hoisted_13 = { class: "d-flex flex-row bottom-pane" }
const _hoisted_14 = { class: "license-panel" }
const _hoisted_15 = { class: "license-list" }
const _hoisted_16 = { class: "badge badge-pill" }
const _hoisted_17 = { class: "support-panel" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  class: "support-img"
}, null, -1)
const _hoisted_19 = { class: "sub-footer" }
const _hoisted_20 = { class: "contact-modes" }
const _hoisted_21 = { class: "contact-type" }
const _hoisted_22 = { class: "contact-body" }
const _hoisted_23 = { class: "heading" }
const _hoisted_24 = /*#__PURE__*/_createElementVNode("div", { class: "contact-footer" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "icon mdp-Phone" }),
  /*#__PURE__*/_createElementVNode("span", null, "+49 (0) 2842 - 92 737 77")
], -1)
const _hoisted_25 = { class: "contact-type" }
const _hoisted_26 = { class: "contact-body" }
const _hoisted_27 = { class: "heading" }
const _hoisted_28 = { class: "contact-footer justify-content-between" }
const _hoisted_29 = /*#__PURE__*/_createElementVNode("span", { class: "d-flex align-items-center" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "icon mdp-Mail" }),
  /*#__PURE__*/_createElementVNode("span", null, "support@itb-pim.de")
], -1)
const _hoisted_30 = {
  class: "btn btn-primary",
  href: "mailto:support@itb-pim.de"
}
const _hoisted_31 = { class: "d-flex justify-content-between" }
const _hoisted_32 = { class: "footer-branding" }
const _hoisted_33 = { class: "footer-logo" }
const _hoisted_34 = /*#__PURE__*/_createElementVNode("img", { src: _imports_1 }, null, -1)

import healthChecksApi from "@services/healthChecks";
import statusApi from "@services/status.js";
import { onMounted, reactive, watch } from "vue";
import { useI18n } from "vue-i18n";
import StatusNode from "./StatusNode.vue";
import ApiLogViewer from "@common/components/ApiLogViewer.vue";
import localeSwitcher from "@common/components/LocaleSwitcher.vue";
import { RootState } from "@medapro-types/common/rootstate";
import { HealthCheckStatus, IHealthCheckModel, IVersionResponse, NodeData, NodeStatus } from "@medapro-types/services/healthChecks";
import _ from "lodash";
import { useState } from "vuex-composition-helpers";


export default /*#__PURE__*/_defineComponent({
  __name: 'ExtendedStatus',
  setup(__props) {

const translate = useI18n().t;

const { meta, userSettings, licenses } = useState<RootState>(["meta", "userSettings", "licenses"]);

const viewModel = reactive({
  nodes: [] as NodeData[],
  isConnected: false,
  colorCodedLicenseStatus: false, //Change this to true if license values need to be color coded.
  licenses: {},
  thirdPartyLicenses: [],
  health: {
    connectivity: { title: "statuspage.title.connectivity", status: NodeStatus.Unknown, feedback: "", url: meta.value.config.apiUrl },
    clientCompatibility: {
      title: "statuspage.title.clientCompatibility",
      status: NodeStatus.Unknown,
      feedback: "",
      data: undefined as IVersionResponse | undefined
    },
    databaseStatus: {
      title: "statuspage.title.databaseConnectivity",
      status: NodeStatus.Unknown,
      feedback: "",
      url: "",
      data: undefined as IHealthCheckModel | undefined
    },
    databaseCompatibility: {
      title: "statuspage.title.databaseCompatibility",
      status: NodeStatus.Unknown,
      feedback: "",
      databaseVersion: "",
      clientVersion: "",
      data: undefined as IHealthCheckModel | undefined
    },
    databseScripts: { title: "statuspage.title.sqlComponents", status: NodeStatus.Unknown, feedback: "", data: undefined as IHealthCheckModel | undefined },
    media: { title: "statuspage.title.media", status: NodeStatus.Unknown, feedback: "", data: undefined as IHealthCheckModel | undefined }
  },
  showThirdPartyLicenseDialog: false
});

/* eslint-disable @typescript-eslint/no-unused-vars */
async function getVersion() {
  try {
    viewModel.health.clientCompatibility.status = NodeStatus.Running;
    viewModel.health.connectivity.status = NodeStatus.Running;
    viewModel.health.connectivity.feedback = translate("statuspage.connectionSuccessful", { url: meta.value.config.apiUrl });
    viewModel.health.clientCompatibility.feedback = translate("statuspage.checkClientVersion");

    const result = await healthChecksApi.getVersion();
    viewModel.isConnected = true;
    viewModel.health.connectivity.status = NodeStatus.Success;

    const apiVersion = (viewModel.health.clientCompatibility.data = result);
    if (apiVersion && apiVersion.version) {
      const api = apiVersion.version.split(".").slice(0, 3);
      const client = (meta.value.version || "").split(".").slice(0, 3);

      //viewModel.health.clientCompatibility.feedback = `Client Version: ${meta.value.version} is  Api version: ${apiVersion.version}`;
      const sources = _.sortBy([api, client], "length"); // sort for iterataing on item with highest number of version segments.
      if (sources[1].every((e, i) => sources[0][i] == e)) {
        viewModel.health.clientCompatibility.status = NodeStatus.Success;
        viewModel.health.clientCompatibility.feedback = translate("statuspage.feedback.clientIsEqual", {
          client: removeRevivisonFromVersion(meta.value.version ?? ""),
          api: removeRevivisonFromVersion(apiVersion.version ?? "")
        });
      } else {
        const isBehindApi = parseInt(api.join("") || "0") > parseInt(client.join("") || "0");
        viewModel.health.clientCompatibility.feedback = translate(
          isBehindApi ? "statuspage.feedback.clientIsBehindApi" : "statuspage.feedback.clientIsAheadApi",
          { client: removeRevivisonFromVersion(meta.value.version ?? ""), api: removeRevivisonFromVersion(apiVersion.version ?? "") }
        );
        if (api[0] === client[0] && api[1] === client[1]) {
          viewModel.health.clientCompatibility.status = NodeStatus.Warning;
        } else {
          viewModel.health.clientCompatibility.status = NodeStatus.Error;
        }
      }
    } else {
      viewModel.health.clientCompatibility.status = NodeStatus.Error;
      viewModel.health.clientCompatibility.feedback = translate("statuspage.versionCheckUnknownResponse");
    }
  } catch (error: any) {
    viewModel.health.connectivity.status = NodeStatus.Error;
    viewModel.health.clientCompatibility.status = NodeStatus.Error;
    viewModel.health.clientCompatibility.feedback = error && error.feedback ? error.feedback : error.message || "network error";
  }
}

/* eslint-disable @typescript-eslint/no-unused-vars */
async function GetDatabaseStatus() {
  try {
    if (!viewModel.isConnected) {
      viewModel.health.databaseStatus.status = NodeStatus.Unknown;
    } else {
      viewModel.health.databaseStatus.status = NodeStatus.Running;
      const result = await healthChecksApi.getDatabaseStatus();
      viewModel.health.databaseStatus.status = NodeStatus.Success;
      if (result.errorType != "ServerError") {
        viewModel.health.databaseStatus.data = result;
        viewModel.health.databaseStatus.feedback = translate("statuspage.feedback.DatabaseConnectionSuccessful");
        viewModel.health.databaseStatus.url = result.params.dataSource + "/" + result.params.database;
      } else viewModel.health.databaseStatus.feedback = translate(result.feedback);
    }
  } catch (error: any) {
    viewModel.health.databaseStatus.status = NodeStatus.Error;
    viewModel.health.databaseStatus.feedback = error && error.feedback ? error.feedback : error.message || "network error";
  }
}

async function getDatabaseCompatibility() {
  try {
    if (!viewModel.isConnected) {
      viewModel.health.databaseCompatibility.status = NodeStatus.Unknown;
    } else {
      viewModel.health.databaseCompatibility.status = NodeStatus.Running;
      const result = await healthChecksApi.getDatabaseCompatibility();
      viewModel.health.databaseCompatibility.status = getStatusString(result.success);
      if (result.errorType != "ServerError") {
        viewModel.health.databaseCompatibility.data = result;
        viewModel.health.databaseCompatibility.databaseVersion = result.params["databaseVersion"];
        viewModel.health.databaseCompatibility.clientVersion = result.params["clientVersion"];
        const versionStatus = compareVersions(viewModel.health.databaseCompatibility.clientVersion, viewModel.health.databaseCompatibility.databaseVersion);
        const dbVersionMessage =
          versionStatus == -1
            ? "statuspage.feedback.DatabaseVersionAheadClient"
            : versionStatus == 1
              ? "statuspage.feedback.DatabaseVersionBehindClient"
              : "statuspage.feedback.DatabaseCompatibleWithClient";

        viewModel.health.databaseCompatibility.feedback = translate(dbVersionMessage, {
          clientVersion: removeRevivisonFromVersion(result.params["clientVersion"]),
          databaseVersion: result.params["databaseVersion"]
        });
      } else viewModel.health.databaseCompatibility.feedback = translate(result.feedback);
    }
  } catch (error: any) {
    viewModel.health.databaseCompatibility.status = NodeStatus.Error;
    viewModel.health.databaseCompatibility.feedback = error && error.feedback ? translate(error.feedback) : error.message || "network error";
  }
}

function removeRevivisonFromVersion(version: string): string {
  const parts = version.split(".");
  if (parts.length <= 3) return version;
  return parts.slice(0, 3).join(".");
}

function compareVersions(v1: string, v2: string) {
  const c1 = v1.split(".").slice(0, 3);
  const c2 = v2.split(".").slice(0, 3);

  const max = Math.max(c1.length, c2.length);
  for (let index = 0; index < max; index++) {
    const part1 = parseInt(c1[index] || "0");
    const part2 = parseInt(c2[index] || "0");

    if (part1 < part2) {
      return -1;
    }
    if (part1 > part2) {
      return 1;
    }
  }

  return 0;
}

async function getDatabaseScriptStatus() {
  try {
    if (viewModel.isConnected == false) {
      viewModel.health.databseScripts.status = NodeStatus.Unknown;
    } else {
      viewModel.health.databseScripts.status = NodeStatus.Running;
      const result = await healthChecksApi.getDatabaseScriptStatus();
      viewModel.health.databseScripts.data = result;
      viewModel.health.databseScripts.status = getStatusString(result.success);
      if (result.errorType != "ServerError") viewModel.health.databseScripts.feedback = translate("statuspage.feedback." + result.params.feedback);
      else viewModel.health.databseScripts.feedback = result.feedback;
    }
  } catch (error: any) {
    viewModel.health.databseScripts.status = NodeStatus.Error;
    viewModel.health.databseScripts.feedback = error && error.feedback ? translate(error.feedback) : error.message || "network error";
  }
}

async function getMediaAssetPaths() {
  try {
    if (viewModel.isConnected == false) {
      viewModel.health.media.status = NodeStatus.Unknown;
    } else {
      viewModel.health.media.status = NodeStatus.Running;
      const result = await healthChecksApi.getMediaPathStatus();
      viewModel.health.media.data = result;
      viewModel.health.media.status = getStatusString(result.success);
      viewModel.health.media.feedback =
        result.success == HealthCheckStatus.OK
          ? translate("statuspage.feedback." + result.params.feedback)
          : result.errorType == "ServerError"
            ? result.feedback
            : translate("statuspage.feedback." + result.errorType);
    }
  } catch (error: any) {
    viewModel.health.media.status = NodeStatus.Error;
    viewModel.health.media.feedback = error && error.feedback ? error.feedback : error.message || "network error";
  }
}

async function runHealthChecks() {
  await getVersion();
  if (!viewModel.isConnected) {
    return;
  }

  await Promise.all([GetDatabaseStatus(), getDatabaseCompatibility(), getDatabaseScriptStatus(), getMediaAssetPaths(), getLicenseInformation()]);
}

async function getLicenseInformation() {
  try {
    viewModel.licenses = licenses.value;
    viewModel.thirdPartyLicenses = await statusApi.getThirdPartyLicence();
  } catch (error) {
    viewModel.licenses = {};
  }
}

function getLicenseType(v: string): string {
  if (!viewModel.colorCodedLicenseStatus) {
    return "badge-secondary";
  }

  if (v == "NotLicensed") return "badge-warning";
  else if (!v || v == "0") return "badge-secondary";

  return "badge-success";
}

function getStatusString(status: HealthCheckStatus): NodeStatus {
  switch (status) {
    case HealthCheckStatus.ERROR:
      return NodeStatus.Error;
    case HealthCheckStatus.OK:
      return NodeStatus.Success;
    case HealthCheckStatus.WARN:
      return NodeStatus.Warning;
  }

  return NodeStatus.Unknown;
}

watch(
  () => userSettings.value.CurrentLocale,
  () => runHealthChecks()
);

onMounted(runHealthChecks);

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_b_card_text = _resolveComponent("b-card-text")!
  const _component_b_tab = _resolveComponent("b-tab")!
  const _component_b_tabs = _resolveComponent("b-tabs")!
  const _component_b_card = _resolveComponent("b-card")!
  const _component_b_modal = _resolveComponent("b-modal")!
  const _directive_safe_class = _resolveDirective("safe-class")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_router_link, {
            to: { name: 'app-base' },
            tag: "button",
            class: "btn btn-secondary btn-with-icon mono"
          }, {
            default: _withCtx(() => [
              _hoisted_5,
              _createTextVNode(" " + _toDisplayString(_unref(translate)("BackToHome")), 1)
            ]),
            _: 1
          })
        ]),
        _createVNode(localeSwitcher, { "show-icon": true })
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", _hoisted_7, [
          _createVNode(_component_b_card, { "no-body": "" }, {
            footer: _withCtx(() => [
              _createElementVNode("div", _hoisted_31, [
                _createElementVNode("div", _hoisted_32, "MeDaPro Everywhere " + _toDisplayString("20" + _unref(meta).version) + " (" + _toDisplayString(removeRevivisonFromVersion(_unref(meta).version)) + ")", 1),
                _createElementVNode("div", _hoisted_33, [
                  _createElementVNode("a", {
                    href: "#",
                    onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (viewModel.showThirdPartyLicenseDialog = true), ["prevent"]))
                  }, _toDisplayString(_unref(translate)("licenses.thirdPartyLicenses")), 1),
                  _hoisted_34
                ])
              ])
            ]),
            default: _withCtx(() => [
              _createVNode(_component_b_tabs, null, {
                default: _withCtx(() => [
                  _createVNode(_component_b_tab, {
                    title: _unref(translate)('about')
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_8, [
                        _createElementVNode("div", _hoisted_9, [
                          _createElementVNode("h3", null, _toDisplayString(_unref(translate)("statuspage.Status")), 1),
                          _createElementVNode("div", null, [
                            _createElementVNode("button", {
                              class: "btn btn-secondary btn-with-icon mono",
                              onClick: runHealthChecks
                            }, _hoisted_11)
                          ])
                        ]),
                        _createVNode(_component_b_card_text, null, {
                          default: _withCtx(() => [
                            _createElementVNode("div", _hoisted_12, [
                              _createVNode(StatusNode, {
                                link: viewModel.health.connectivity.url,
                                "is-link-interactive": true,
                                title: _unref(translate)(viewModel.health.connectivity.title),
                                description: viewModel.health.connectivity.feedback,
                                status: viewModel.health.connectivity.status
                              }, null, 8, ["link", "title", "description", "status"]),
                              _createVNode(StatusNode, {
                                title: _unref(translate)(viewModel.health.clientCompatibility.title),
                                description: viewModel.health.clientCompatibility.feedback,
                                status: viewModel.health.clientCompatibility.status
                              }, null, 8, ["title", "description", "status"]),
                              _createVNode(StatusNode, {
                                title: _unref(translate)(viewModel.health.media.title),
                                description: viewModel.health.media.feedback,
                                status: viewModel.health.media.status
                              }, null, 8, ["title", "description", "status"]),
                              _createVNode(StatusNode, {
                                link: viewModel.health.databaseStatus.url,
                                title: _unref(translate)(viewModel.health.databaseStatus.title),
                                description: viewModel.health.databaseStatus.feedback,
                                status: viewModel.health.databaseStatus.status
                              }, null, 8, ["link", "title", "description", "status"]),
                              _createVNode(StatusNode, {
                                title: _unref(translate)(viewModel.health.databaseCompatibility.title),
                                description: viewModel.health.databaseCompatibility.feedback,
                                status: viewModel.health.databaseCompatibility.status
                              }, null, 8, ["title", "description", "status"]),
                              _createVNode(StatusNode, {
                                title: _unref(translate)(viewModel.health.databseScripts.title),
                                description: viewModel.health.databseScripts.feedback,
                                status: viewModel.health.databseScripts.status
                              }, null, 8, ["title", "description", "status"])
                            ]),
                            _createElementVNode("div", _hoisted_13, [
                              _createElementVNode("div", _hoisted_14, [
                                _createElementVNode("h3", null, _toDisplayString(_unref(translate)("statuspage.licenseInformation")), 1),
                                _createElementVNode("div", _hoisted_15, [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(viewModel.licenses, (value, key) => {
                                    return (_openBlock(), _createElementBlock("div", {
                                      class: "license-node",
                                      key: key
                                    }, [
                                      _createElementVNode("span", null, _toDisplayString(_unref(translate)(`licenses.${key}`)), 1),
                                      _withDirectives((_openBlock(), _createElementBlock("span", _hoisted_16, [
                                        _createTextVNode(_toDisplayString(value), 1)
                                      ])), [
                                        [_directive_safe_class, getLicenseType(value)]
                                      ])
                                    ]))
                                  }), 128))
                                ])
                              ]),
                              _createElementVNode("div", _hoisted_17, [
                                _createElementVNode("h3", null, _toDisplayString(_unref(translate)("statuspage.needAssistance")), 1),
                                _createElementVNode("div", null, _toDisplayString(_unref(translate)("statuspage.weAnswerQuestions")), 1),
                                _createElementVNode("p", null, _toDisplayString(_unref(translate)("statuspage.firstPointOfContact")), 1),
                                _hoisted_18,
                                _createElementVNode("h4", null, [
                                  _createTextVNode(_toDisplayString(_unref(translate)("statuspage.supportTeamWillHelp")) + " ", 1),
                                  _createElementVNode("div", _hoisted_19, _toDisplayString(_unref(translate)("statuspage.fastHelp")), 1)
                                ]),
                                _createElementVNode("div", _hoisted_20, [
                                  _createElementVNode("div", _hoisted_21, [
                                    _createElementVNode("div", _hoisted_22, [
                                      _createElementVNode("div", _hoisted_23, _toDisplayString(_unref(translate)("statuspage.callUs")), 1),
                                      _createElementVNode("div", null, _toDisplayString(_unref(translate)("statuspage.callTiming")), 1)
                                    ]),
                                    _hoisted_24
                                  ]),
                                  _createElementVNode("div", _hoisted_25, [
                                    _createElementVNode("div", _hoisted_26, [
                                      _createElementVNode("div", _hoisted_27, _toDisplayString(_unref(translate)("statuspage.emailUs")), 1)
                                    ]),
                                    _createElementVNode("div", _hoisted_28, [
                                      _hoisted_29,
                                      _createElementVNode("a", _hoisted_30, _toDisplayString(_unref(translate)("statuspage.emailButtonText")), 1)
                                    ])
                                  ])
                                ])
                              ])
                            ])
                          ]),
                          _: 1
                        })
                      ])
                    ]),
                    _: 1
                  }, 8, ["title"]),
                  _createVNode(_component_b_tab, {
                    title: _ctx.$t('logs')
                  }, {
                    default: _withCtx(() => [
                      _createVNode(ApiLogViewer)
                    ]),
                    _: 1
                  }, 8, ["title"])
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ])
      ])
    ]),
    _createVNode(_component_b_modal, {
      size: "lg",
      "dialog-class": "third-party-licenses",
      "footer-class": "border-0",
      scrollable: "",
      "ok-only": "",
      "ok-title": _unref(translate)('close'),
      modelValue: viewModel.showThirdPartyLicenseDialog,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((viewModel.showThirdPartyLicenseDialog) = $event)),
      "header-close-content": "",
      title: _unref(translate)('licenses.thirdPartyLicenses')
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", null, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(viewModel.thirdPartyLicenses, (item, index) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "license-item",
              key: index
            }, [
              _createElementVNode("pre", null, _toDisplayString(item), 1)
            ]))
          }), 128))
        ])
      ]),
      _: 1
    }, 8, ["ok-title", "modelValue", "title"])
  ]))
}
}

})